import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {MsalProvider} from "@azure/msal-react";
import {BrowserCacheLocation, Configuration, PublicClientApplication} from "@azure/msal-browser";
import {AppProvider} from "./context/AppContext";
import {GroupsProvider} from "./context/GroupsContext";
import {IoProvider} from "socket.io-react-hook";

const configuration: Configuration = {
    auth: {
        clientId: "5d1f1f34-2363-4dcc-8e38-501ea17ccd10",
        authority: 'https://login.microsoftonline.com/ae282a38-ef9b-4752-8974-a2f58d87259e'
    },
    cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage
    }
};

const pca = new PublicClientApplication(configuration);

ReactDOM.render(
    <React.StrictMode>
        <MsalProvider instance={pca}>
            <IoProvider>
                <AppProvider>
                    <GroupsProvider>
                        <React.StrictMode>
                            <App />
                        </React.StrictMode>
                    </GroupsProvider>
                </AppProvider>
            </IoProvider>
        </MsalProvider>
    </React.StrictMode>,
  document.getElementById('root')
);
